import { LOOKUP } from "../../api/endpoints";
import { baseApi } from "./baseApi";

export const lookupApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCountries: build.query({
      query: (params = {}) => ({
        url: LOOKUP.COUNTRIES,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Lookup", id: "COUNTRIES" }],
    }),
    getUnitedStatesId: build.query({
      query: () => ({ url: LOOKUP.COUNTRIES, method: "GET" }),
      transformResponse: (response) => {
        const countries =
          response?.data?.list ?? response?.list ?? response ?? [];
        const us = Array.isArray(countries)
          ? countries.find(
              (c) =>
                c.name === "United States" ||
                c.name === "United States of America",
            )
          : null;
        return us?.id ?? null;
      },
      providesTags: [{ type: "Lookup", id: "US" }],
    }),
    getStates: build.query({
      query: (countryId) => ({
        url: LOOKUP.COUNTRY_BY_ID(countryId),
        method: "GET",
      }),
      providesTags: (_r, _e, countryId) => [
        { type: "Lookup", id: `STATES-${countryId}` },
      ],
    }),
    getStatesByCountryId: build.query({
      query: (countryId) => ({
        url: LOOKUP.COUNTRY_STATE_BY_ID(countryId),
        method: "GET",
      }),
      providesTags: (_r, _e, countryId) => [
        { type: "Lookup", id: `STATES-${countryId}` },
      ],
    }),
    getAttributeTypes: build.query({
      query: (params = {}) => ({
        url: LOOKUP.ATTRIBUTE_TYPES,
        method: "GET",
        params,
      }),
      transformResponse: (response) => {
        try {
          localStorage.setItem("attributeTypes", JSON.stringify(response));
        } catch (e) {
          // ignore storage failures
        }
        return response;
      },
      providesTags: [{ type: "Lookup", id: "ATTRIBUTE_TYPES" }],
    }),
    getEquipmentTypes: build.query({
      query: () => ({ url: LOOKUP.EQUIPMENT_TYPES, method: "GET" }),
      providesTags: [{ type: "Lookup", id: "EQUIPMENT_TYPES" }],
    }),
    getEquipmentModels: build.query({
      query: (params = {}) => ({
        url: LOOKUP.EQUIPMENT_MODELS,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Lookup", id: "EQUIPMENT_MODELS" }],
    }),
    getManufacturers: build.query({
      query: (params = {}) => ({
        url: LOOKUP.MANUFACTURERS,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Lookup", id: "MANUFACTURERS" }],
    }),
    getBankruptTypes: build.query({
      query: () => ({ url: LOOKUP.BANKRUPT_TYPES, method: "GET" }),
      providesTags: [{ type: "Lookup", id: "BANKRUPT_TYPES" }],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useLazyGetCountriesQuery,
  useGetUnitedStatesIdQuery,
  useLazyGetUnitedStatesIdQuery,
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useGetStatesByCountryIdQuery,
  useLazyGetStatesByCountryIdQuery,
  useGetAttributeTypesQuery,
  useLazyGetAttributeTypesQuery,
  useGetEquipmentTypesQuery,
  useLazyGetEquipmentTypesQuery,
  useGetEquipmentModelsQuery,
  useLazyGetEquipmentModelsQuery,
  useGetManufacturersQuery,
  useLazyGetManufacturersQuery,
  useGetBankruptTypesQuery,
  useLazyGetBankruptTypesQuery,
} = lookupApi;
